//#region src/domain/i18n/currency-symbol.ts
var CurrencySymbol = /* @__PURE__ */ function(CurrencySymbol) {
	CurrencySymbol["DOP"] = "RD$";
	CurrencySymbol["GTQ"] = "Q";
	CurrencySymbol["HNL"] = "L";
	return CurrencySymbol;
}({});
//#endregion
export { CurrencySymbol };

//# sourceMappingURL=currency-symbol.js.map